import React, { useEffect, useState } from "react";
import { DEFAULT_BATCH_YEAR, BATCH_OPTIONS, SUBJECTS_ENUM } from "../../config";
import SnackbarComponent from "../Common/SnackbarComponent";
import Banner from "../Common/Banner";
import Loader from "../Common/Loader";
import TotalCount from "../AdminDashboard/TotalCount";
import { Stack } from "@mui/system";
import { Button, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import Graph from "../AdminDashboard/Graph";
import { useNavigate } from "react-router-dom";
import StudentMarksTable from "./StudentMarksTable";
import api from "../Auth/Middleware";
import TableFilter from "./TableFilter";
import DynamicPieChart from "../AdminDashboard/DynamicPieChart";

function TeacherDashboard() {
  const [isLoading, setIsLoading] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [snackbarMsg, setSnackbarMSg] = useState("");
  const [snackbarSevierty, setSnackbarSevierty] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [studentData, setStudentData] = useState(null);
  const [selectedClass, setSelectedClass] = useState("6th");
  const [selectedSubject, setSelectedSubject] = useState("Maths");
  const [testByMonth, setTestByMonth] = useState(null);
  const [testByClass, setTestByClass] = useState(null);
  const [totalTests, setTotalTests] = useState(0);
  const role = sessionStorage.getItem("role");
  const [batch, setBatch] = useState(
    role === "Admin"
      ? (parseInt(sessionStorage.getItem("selectedBatch")) || DEFAULT_BATCH_YEAR)
      : DEFAULT_BATCH_YEAR
  );

  const handleBatchChange = (e) => {
    setBatch(e.target.value);
    sessionStorage.setItem("selectedBatch", e.target.value);
  };

  const navigate = useNavigate();

  useEffect(() => {
    setIsTableLoading(true);
    const fetchData = async () => {
      try {
        const response = await api.get(
          `Student/StudentDetailsByClassAndSubject?class=${selectedClass.slice(
            0,
            -2
          )}&course=${SUBJECTS_ENUM[selectedSubject]}&batch=${batch}`
        );
        await setStudentData(response?.data);
        setIsTableLoading(false);
      } catch (error) {
        setIsTableLoading(false);
        setSnackbarOpen(true);
        setSnackbarMSg("API Error Occured");
        setSnackbarSevierty("error");
      }
    };
    fetchData();
  }, [selectedClass, selectedSubject, batch]);

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await api.get(`Student/TestDetail?batch=${batch}`);
        await handleBarData(response?.data?.testByMonth);
        await handlePieData(response?.data?.testByClass);
        await setTotalTests(response?.data.totalTests);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        setSnackbarOpen(true);
        setSnackbarMSg(`API Error Occured - ${error}`);
        setSnackbarSevierty("error");
      }
    };
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batch]);

  const handleFilterChange = (selectedClass, selectedSubject) => {
    // Update the state or perform filtering logic here
    setSelectedClass(selectedClass);
    setSelectedSubject(selectedSubject);
  };

  const handleAddScore = () => {
    navigate("/addScore");
  };

  const closeSnackbar = () => {
    setSnackbarOpen(false);
  };

  
  const handlePieData = (data) => {
    const PieData = data?.map((obj) => ({
      label: `${obj.class}th`,
      value: obj.count,
    }));
    setTestByClass(PieData);
  };
  const monthNames = {
    1: "Jan",
    2: "Feb",
    3: "Mar",
    4: "Apr",
    5: "May",
    6: "Jun",
    7: "Jul",
    8: "Aug",
    9: "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec",
  };

  const handleBarData = (data) => {
    const sortedData = data?.sort((a, b) => a.month - b.month);
    const transformedArray = sortedData?.map((obj) => ({
      month: monthNames[obj.month],
      yValue: obj.numberOfTests,
    }));
    setTestByMonth(transformedArray);
  };

  return (
    <>
      <SnackbarComponent
        open={snackbarOpen}
        severity={snackbarSevierty}
        message={snackbarMsg}
        onClose={closeSnackbar}
      ></SnackbarComponent>
      <Banner title="Teacher Dashboard" currentpage="Teacher Dashboard" />
      <div className="container">
        {role === "Admin" && (
          <div className="mt-4">
            <FormControl fullWidth>
              <InputLabel id="batch-select-label">Select Batch</InputLabel>
              <Select
                labelId="batch-select-label"
                value={batch}
                onChange={handleBatchChange}
                label="Select Batch"
              >
                {BATCH_OPTIONS.map((b) => (
                  <MenuItem key={b} value={b}>{b}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        )}
        <div className="row">
          <div className="col-md-6 col-sm-12">
            {isLoading ? <Loader /> : testByMonth ? <Graph data={testByMonth} label={"Test Conducted - By Month"} xlabel={"Number of Tests"}/> : <p className="border my-5 py-5 text-center">No Data Available</p>}
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="row">
              <div className="col-md-12 col-sm-12">
                {isLoading ? (
                  <Loader />
                ) : (
                  <TotalCount
                    msg={`Total Test Conducted`}
                    count={totalTests}
                    isFees={false}
                  />
                )}
              </div>
              <div className="col-md-12 col-sm-12">
                {isLoading ? (
                  <Loader />
                ) : (
                  <DynamicPieChart data={testByClass} label={"Tests Conducted - By Class"} dataLabel={"Tests"}/>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5">
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddScore}
            >
              Add/Edit Score
            </Button>
          </Stack>
        </div>

        <div className="row my-5">
          <div className="col-md-12">
            <TableFilter onFilterChange={handleFilterChange} />
            {isTableLoading ? (
              <div className="text-center">
                {" "}
                <Loader className="ml-2" />{" "}
              </div>
            ) : studentData?.students ? (
              <StudentMarksTable data={studentData} />
            ) : (
              <p className="my-5 mx-auto py-5 px-5 border border-2">
                No Marks Available
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default TeacherDashboard;
